import { render, staticRenderFns } from "./expendituresList.vue?vue&type=template&id=33a749c4&scoped=true&"
import script from "./expendituresList.vue?vue&type=script&lang=js&"
export * from "./expendituresList.vue?vue&type=script&lang=js&"
import style0 from "./expendituresList.vue?vue&type=style&index=0&id=33a749c4&lang=scss&scoped=true&"
import style1 from "./expendituresList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a749c4",
  null
  
)

export default component.exports